<template>
  <div class="text-white">
    <h1 class="text-2xl px-3 font-semibold">Создание района</h1>
    <div class="my-4 px-3 flex justify-between items-center">
      <label class="mr-3">Название <i style="color: red">*</i></label>
      <input
        class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
        type="text"
        placeholder="Название"
        v-model="district.name"
      />
    </div>
    <div class="my-4 px-3 flex justify-between items-center">
      <label>Зона </label>
      <div class="w-[270px]">
        <customSelect
          :options="zones"
          v-model="district.group_id"
          label="name"
          value-key="id"
          :search="true"
        ></customSelect>
      </div>
    </div>
    <div class="my-4 px-3 flex justify-between items-center">
      <p class="mr-12">Площадь</p>
      <p>{{ square }} кв.км.</p>
    </div>
    <div class="my-4 px-3 flex justify-between">
      <label>WKT <i style="color: red">*</i></label>
      <input
        class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
        type="text"
        placeholder="WKT"
        v-model="district.polygon"
      />
    </div>
    <div class="flex justify-between my-4 px-3">
      <button
        class="bg-white text-black rounded-sm mr-2 p-1 cursor-pointer"
        @click="$emit('createDistrict'), closeForm()"
      >
        Отмена
      </button>
      <button
        class="rounded ml-2 p-1 cursor-pointer"
        :disabled="isActive"
        :class="isActive ? 'bg-black/40 text-white' : ' bg-white text-black'"
        @click="postDistrict"
      >
        Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import converter from "@/util/converterToGeojsonOrPolygon.js";
import customSelect from "@/components/custom/customSelect/index.vue";
import L from "leaflet";
export default {
  components: {
    customSelect,
  },
  props: ["village_id", "addDistrictsData", "zones"],
  data() {
    return {
      district: {
        name: "",
        group_id: null,
        polygon: null,
        lat: null,
        lng: null,
      },
      square: null,
      isActive: false,
    };
  },
  watch: {
    addDistrictsData(newValue) {
      if (newValue.center.length == 0) return;
      this.calculatorSquare(newValue);
      this.district.polygon = newValue.polygon[0].coordinatesPolygon.map(
        (e) => [e.coords[0][1], e.coords[0][0]]
      );
      this.district.lat = newValue.center[0]._latlng.lat;
      this.district.lng = newValue.center[0]._latlng.lng;
    },
  },
  methods: {
    calculatorSquare(newValue) {
      let erea = L.GeometryUtil.geodesicArea(
        newValue.polygon[0].polygonObject.getLatLngs()[0]
      );
      this.square = erea.toFixed(0);
    },
    postDistrict() {
      this.isActive = true;
      this.district.geometry = converter.encodePolyline(
        this.district.polygon.map((e) => [e[1], e[0]])
      );
      this.$http
        .post(`v1/polygons/${this.village_id}/child`, this.district)
        .then(() => {
          this.$toast.open({
            type: "success",
            position: "top",
            message: "Района создан",
          });
          this.close();
        })
        .catch((error) => {
          this.$toast.open({
            type: "error",
            position: "top",
            message: error,
          });
        })
        .finally(() => {
          this.isActive = false;
        });
    },
    close() {
      this.closeForm();
      this.$emit("close");
    },
    closeForm() {
      (this.district = {
        name: "",
        group_id: null,
        polygon: null,
        lat: null,
        lng: null,
      }),
        (this.square = null);
    },
  },
};
</script>
